// This file contains global constants that are used throughout different apps of the Pentacode application.
import { multiplyWithFactor } from "@pentacode/openapi";
import { hour } from "./time/consts";
export const GLOBAL_CONSTANTS = {
    VACATION_FUTURE_LIMIT_MONTHS: 18, // This is the maximum number of months into the future that a vacation request can be made.
    MIN_REST_MS: multiplyWithFactor(hour, 11), // This is the minimum rest period between shifts on different dates (ArbZG §5)
    ASSUMED_SHIFT_MS: multiplyWithFactor(hour, 10), // Assumed duration for shifts with only one planned side (start XOR end).
};
//# sourceMappingURL=global-constants.js.map